var _a;
const windowWithFaro = window;
// Maintain Faro queue on window, as 2 different scripts are working with it - faro bundle and app bundle,
// so if made local, it will be local per script
(_a = windowWithFaro.openPassFaroQueue) !== null && _a !== void 0 ? _a : (windowWithFaro.openPassFaroQueue = { measurements: [], events: [] });
const faroQueue = windowWithFaro.openPassFaroQueue;
export const pushFaroMeasurement = (measurement) => {
    const { faro } = windowWithFaro;
    if (faro) {
        try {
            faro.api.pushMeasurement(measurement);
        }
        catch (error) {
            console.error("Error pushing Faro measurement", measurement, error);
        }
    }
    else {
        faroQueue.measurements.push(measurement);
    }
};
export const pushFaroEvent = (event) => {
    const { faro } = windowWithFaro;
    if (faro) {
        try {
            faro.api.pushEvent(event.name, event.attributes);
        }
        catch (error) {
            console.error("Error pushing Faro event", event, error);
        }
    }
    else {
        faroQueue.events.push(event);
    }
};
export const pushFaroQueue = () => {
    const { faro } = windowWithFaro;
    if (!faro) {
        console.error("Faro isn't initialized");
        return;
    }
    const { measurements, events } = faroQueue;
    measurements.forEach((measurement) => {
        try {
            faro.api.pushMeasurement(measurement);
        }
        catch (error) {
            console.error("Error pushing Faro measurement", measurement, error);
        }
    });
    faroQueue.measurements = [];
    events.forEach((event) => {
        try {
            faro.api.pushEvent(event.name, event.attributes);
        }
        catch (error) {
            console.error("Error pushing Faro event", event, error);
        }
    });
    faroQueue.events = [];
};
